import styled from 'styled-components'

import { theme } from '@/styles/theme'

import { AccordionFilter } from './AccordionFilter'
import { BlogTagButton } from '@/components/elements/Blog/BlogTagButton'
import { Line } from '@/components/elements/Line'

import type { BlogTag } from '@/types/blog'

type Props = {
  years: readonly string[]
  tagList: readonly Pick<BlogTag, '_id' | 'name' | 'tagColor'>[]
  selectedTags: readonly string[]
  selectedYears: readonly string[]
  changeSelectedYear: (year: string) => void
  changeSelectedTag: (text: string) => void
  handleAllTags: () => void
  handleAllYears: () => void
}

export const Filter = ({
  years,
  tagList,
  selectedTags,
  selectedYears,
  changeSelectedYear,
  changeSelectedTag,
  handleAllTags,
  handleAllYears,
}: Props) => {
  return (
    <AccordionFilter>
      <Field>
        <Title>掲載日</Title>
        <TagList>
          <BlogTagButton
            tag={{ tagColor: theme.colors.trialBlue, name: 'すべて' }}
            isActive={selectedYears.length === 0}
            onClick={handleAllYears}
            disabled={selectedYears.length === 0}
          />
          {years.map((year) => (
            <BlogTagButton
              tag={{ tagColor: theme.colors.textSecond, name: year }}
              key={year}
              isActive={selectedYears.includes(year)}
              onClick={() => changeSelectedYear(year)}
            />
          ))}
        </TagList>
      </Field>
      <SpLine color="grey" weight={1} direction="horizon" />
      <Field>
        <Title>タグ</Title>
        <TagList>
          <BlogTagButton
            tag={{ tagColor: theme.colors.trialBlue, name: 'すべて' }}
            isActive={selectedTags.length === 0}
            onClick={handleAllTags}
            disabled={selectedTags.length === 0}
          />
          {tagList.map(({ _id, name, tagColor }) => (
            <BlogTagButton
              tag={{ tagColor, name: `#${name}` }}
              key={_id}
              isActive={selectedTags.includes(name)}
              onClick={() => changeSelectedTag(name)}
            />
          ))}
        </TagList>
      </Field>
    </AccordionFilter>
  )
}

const Field = styled.div`
  display: block;

  @media screen and (max-width: 1047px) {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
`

const Title = styled.div`
  display: none;

  @media screen and (max-width: 1047px) {
    display: block;
    font-size: 14px;
    letter-spacing: 0;
    line-height: 24px;
    color: ${theme.colors.textTitle};
  }
`

const TagList = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
`

const SpLine = styled(Line)`
  display: none;

  @media screen and (max-width: 1047px) {
    display: block;
  }
`
